<template>
  <div>
    <el-card class="step__">
      <div slot="header" class="clearfix">
        <div class="title">
          <span class="line"></span>
          <span>第一步：选择模板</span>
        </div>
      </div>
      <div>
        <el-input v-model="griCode" placeholder="搜索GRI编码或名称" clearable @keyup.enter.native="getTemplateList" @clear="getTemplateList">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div style="margin-top: 10px;display: flex;flex-wrap: wrap;max-height: 550px;overflow: auto">
        <div class="list__item" :class="{'selected':item.tplId === selectedTemplate.tplId}" v-for="item in itemList" @click="selectItem(item)">
          <div style="display: flex;align-items: flex-start;">
            <div style="min-width: 50px;text-align: center;background: #ECF2FF;border: 1px solid #D9E6FF;font-size: 12px;color: #408EFF;padding: 1px 5px;border-radius: 5px;">{{item.griCode}}</div>
            <div style="margin-left: 10px;color: #303133;font-weight: bold;">{{item.griName}}</div>
          </div>
          <div style="margin-top: 15px;">
            <div style="display: flex;justify-content: space-between;">
              <div style="color: #909399;">Category2:</div>
              <div style="color:#606266;">{{item.category2Name}}</div>
            </div>
            <div style="margin-top: 5px;display: flex;justify-content: space-between;">
              <div style="color: #909399;">Category3:</div>
              <div style="color:#606266;">{{item.category3Name}}</div>
            </div>
          </div>
          <el-divider></el-divider>
          <div style="display: flex;justify-content: space-between;font-size: 12px;color: #909399;">
            <div>{{item.processCount}} 个制成</div>
            <div>{{item.paramCount}} 个参数</div>
          </div>
          <el-divider></el-divider>
          <div style="font-size: 12px;color: #A9AEB8">{{item.comments}}</div>
        </div>
      </div>
    </el-card>
    <el-card class="step__">
      <div slot="header" class="clearfix">
        <div class="title">
          <span class="line"></span>
          <span>第二步：下载模板</span>
        </div>
      </div>
      <div>
        <el-button size="mini" class="btn" type="primary" @click="downloadTemplate" :disabled="!selectedTemplate.tplId">下载模板</el-button>
        <span style="margin-left: 10px;font-size:12px;color: red;">请先选择模板</span>
      </div>
    </el-card>
    <el-card class="step__">
      <div slot="header" class="clearfix">
        <div class="title">
          <span class="line"></span>
          <span>第三步：上传文件</span>
        </div>
      </div>
      <div style="text-align: center;">
        <el-upload v-if="!currentFileName" ref="upload"
            class="upload-demo"
            :class="{'upload__disabled': !selectedTemplate.tplId}"
            drag
            action=""
            :headers="uploadHeader"
            :show-file-list="false"
            :http-request="customUpload"
            :before-upload="beforeUpload"
            :disabled="!selectedTemplate.tplId">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件，且不超过10MB</div>
          <div slot="tip">
            <div style="font-size: 14px; margin-bottom: 5px;" v-if="currentFileName">
              {{ currentFileName }}
            </div>
            <div style="font-size: 12px;" v-if="showErrorDownload && errorMsgList && errorMsgList.length > 0" class="a-link" @click="downloadErrorMessage">导入错误信息.txt</div>
          </div>
        </el-upload>
        <el-upload v-if="currentFileName" ref="uploadRef"
                   class="upload-demo"
                   :class="{'upload__disabled': !selectedTemplate.tplId}"
                   action=""
                   :headers="uploadHeader"
                   :show-file-list="false"
                   :http-request="customUpload"
                   :before-upload="beforeUpload"
                   :disabled="!selectedTemplate.tplId">
<!--          <div class="el-upload__text"></div>-->
<!--          <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件，且不超过10MB</div>-->
          <div slot="tip">
            <div style="display: flex;justify-content: center;align-items: center;">
              <div style="max-width: 50%;">{{currentFileName}}</div>
              <div style="margin-left: 30px;">
                <el-button size="mini" class="btn" type="primary" @click="doUpload">重新上传</el-button>
                <el-button size="mini" class="btn" type="danger" @click="doDelete">删除</el-button>
              </div>
            </div>
            <div style="font-size: 12px;margin-top: 15px;" v-if="showErrorDownload && errorMsgList && errorMsgList.length > 0" class="a-link" @click="downloadErrorMessage">导入错误信息.txt</div>
          </div>
        </el-upload>
      </div>
    </el-card>
    <el-divider></el-divider>
    <div style="display: flex;justify-content: flex-end;">
      <el-button size="mini" class="btn" type="primary" @click="cancelImport">取消</el-button>
      <el-button size="mini" class="btn" type="primary" @click="confirmImport" :disabled="!showErrorDownload">确认导入</el-button>
    </div>
  </div>
</template>

<script>

  import ppmApi from "@/api/productionProcessMonitoring";
  import {fileService} from "@/api/common/file-utils";
  import commonFunction from "@/utils/dataTableUtils";

  export default {
    props: ["batchType"],
    data() {
      return {
        griCode: "",
        templateType: "",
        itemList: [],
        selectedTemplate: {},
        currentFileName: "",
        uploadUrl: "",
        uploadData: null,
        file: "",
        showErrorDownload: false,     // 是否展示错误信息下载
        errorMsgList: []
      }
    },
    watch: {
      batchType: {
        handler(val) {
          if(val) {
            this.doDelete();
            this.templateType = val;
            this.getTemplateList();
          }
        },
        immediate: true
      }
    },
    created() {

    },
    methods: {
      async getTemplateList() {
        let request = {
          griCode: this.griCode,
          status: "ACTIVE",
          templateType: this.templateType,
          isLatest: 1
        };
        let res = await ppmApi.getProcessTemplateList(request);
        if(res.code == 200) {
          this.itemList = res.data.records;
        }
      },
      selectItem(item) {
        this.selectedTemplate = item;
        this.uploadUrl = "/adminconsole/process/record/import/" + this.selectedTemplate.tplId;
      },
      // 下载导入模板
      downloadTemplate() {
        ppmApi.downloadImportTemplate(this.selectedTemplate.tplId).then(res => {
          fileService.respToFile(res, null);
        })
      },
      doUpload() {
        let uploadRef = this.$refs.uploadRef;
        if(uploadRef) {
          this.$refs.uploadRef.$el.querySelector('input[type="file"]').click();
        }
      },
      // 删除上传的附件
      doDelete() {
        let uploadRef = this.$refs.uploadRef;
        if(uploadRef) {
          uploadRef.clearFiles();
          this.currentFileName = "";
          this.showErrorDownload = false;
        }
      },
      beforeUpload(file) {
        this.currentFileName = file.name;
        const fileExtension = file.name.split('.').pop().toLowerCase();
        const isExtensionValid = ['xlsx', 'xls'].includes(fileExtension);
        const isLt10M = file.size / 1024 / 1024 < 10;
        if(!isExtensionValid) {
          this.$message.error("只能上传xlsx/xls文件");
          return false;
        }
        if (!isLt10M) {
          this.$message.error("上传文件大小不能超过10MB");
          return false;
        }
        return true;
      },
      customUpload(file) {
        this.errorMsgList = [];
        this.showErrorDownload = false;
        this.file = file.file;
        this.currentFileName = file.file.name;
        const formData = new FormData();
        formData.append('file', file.file);
        formData.append('tplId', this.selectedTemplate.tplId);
        this.uploadData = new FormData();
        this.uploadData.append('file', file.file);
        this.uploadData.append('confirmed', false);
        this.uploadData.append('tplId', this.selectedTemplate.tplId);
        ppmApi.importTemplateData(this.selectedTemplate.tplId, formData).then(res => {
          if(res.meta.code == 200) {
            // this.showErrorDownload = false;
            // this.selectedTemplate = {};
            // this.$message.success("导入成功");
            // this.uploadData = null;
            // this.doDelete();
            // this.$emit("onUploadSuccess");
          } else if(res.meta.code == 400) {
            if(res.meta.msg) {
              let wordText = res.meta.msg.split('\n');
              wordText.forEach(ele => {
                let str = ele + '\n';
                this.errorMsgList.push(str);
              });
              if(this.errorMsgList && this.errorMsgList.length > 0) {
                this.showErrorDownload = true;
                this.$message.error("导入错误，错误信息可通过下方链接下载后进行查看");
              } else {
                this.showErrorDownload = false;
                this.$message.error("文件上传失败");
              }
            } else {
              this.showErrorDownload = true;
              this.errorMsgList = null;
              this.$message.warning("数据无异常，若需导入，请点击“确认导入”按钮即可");
            }
            // this.$confirm('导入错误信息是否下载?', {
            //   showCancelButton: true,
            //   confirmButtonText: '导入错误信息下载',
            //   confirmButtonClass: "confirmButtonClass",
            //   cancelButtonClass: "cancelButtonClass",
            //   cancelButtonText: '取消',
            //   type: 'warning'
            // }).then(() => {
            //   let str = new Blob(this.errorMsgList, { type: 'text/plain;charset=utf-8' })
            //   saveAs(str, '导入错误信息.txt')
            //   this.$refs.upload.clearFiles()
            // }).catch(() => {
            //   this.$message.info('已取消导出失败原因')
            //   this.$refs.upload.clearFiles()
            // })
          } else {
            this.$message.error("文件上传失败");
          }
        }).catch(() => {
          this.showErrorDownload = false;
        })
      },
      confirmImport() {
        this.uploadData = new FormData();
        this.uploadData.append('file', this.file);
        this.uploadData.append('confirmed', true);
        this.uploadData.append('tplId', this.selectedTemplate.tplId);
        ppmApi.importTemplateData(this.selectedTemplate.tplId, this.uploadData).then(res => {
          if(res.meta.code == 200) {
            this.showErrorDownload = false;
            this.selectedTemplate = {};
            this.$message.success("导入成功");
            this.uploadData = null;
            this.doDelete();
            this.$emit("onUploadSuccess");
          } else if(res.meta.code == 400) {
            this.errorMsgList = [];
            let wordText = res.meta.msg.split('\n');
            wordText.forEach(ele => {
              let str = ele + '\n';
              this.errorMsgList.push(str);
            });
            if(this.errorMsgList && this.errorMsgList.length > 0) {
              this.showErrorDownload = true;
              this.$message.error("导入错误，错误信息可通过下方链接下载后进行查看");
            } else {
              this.showErrorDownload = false;
              this.$message.error("文件上传失败");
            }
          } else {
            this.showErrorDownload = false;
            this.$message.error("文件上传失败");
          }
        }).catch(() => {
          this.showErrorDownload = false;
        })
      },
      cancelImport() {
        this.selectedTemplate = {};
        this.doDelete();
        this.$emit("cancelImport");
      },
      downloadErrorMessage() {
        let str = new Blob(this.errorMsgList, { type: 'text/plain;charset=utf-8' })
        saveAs(str, '导入错误信息.txt')
      }
    },
    extends: commonFunction
  }

</script>

<style scoped>
:deep(.step__ .el-card__header) {
  padding: 10px !important;
  background: linear-gradient(to right, #F5F5DC, #FFFA77);
}

:deep(.step__ .el-card__header .title) {
  display: flex;
  align-items: center;
}

.list__item {
  width: 300px;
  padding: 20px 15px;
  margin: 5px;
  border: 1px solid #DDDDDD;
  border-radius: 5px;
}

.list__item:hover {
  border: 2px solid #F8AB01;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.1);
}

.list__item.selected {
  border: 2px solid #F8AB01;
  background-color: lightyellow;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

:deep(.el-upload-dragger) {
  width: 700px !important;
}

.upload__disabled {
  opacity: 0.4;
}

:deep(.upload__disabled .el-upload) {
  cursor: default !important;
}

:deep(.upload__disabled .el-upload-dragger) {
  cursor: default !important;
}
</style>